import PdfLayout from '../PdfLayout';
import CustomTextWidget from './CustomTextWidget';
import moment from 'moment';
import { previewOwner } from '../../services/pdfLayoutPreviewSample';

/**
 * Class representing a PDF layout widget showing
 * an information about the ticket owner.
 */
class OwnerInfoWidget extends CustomTextWidget {

    constructor(properties) {
        super({
            ...(OwnerInfoWidget.getDefaultOptions()),
            ...properties,
        });

        this.type    = PdfLayout.TEXT;
        this.subType = PdfLayout.OWNER_INFO;
    }

    /**
     * Get this widget default options
     */
    static getDefaultOptions() {
        return {
            position: { x: 2, y: 2, z: 0 },
            dimensions : { width: 5, height: 0.75 },
            transform: { rotation: 0 },
            options: {
                field: 'fullname',
                style: {
                    color: '#000000',
                    fontFamily: "Helvetica",
                    fontSize: 14,
                    lineHeight: 1,
                    textAlign: 'left',
                    textDecoration: 'none',
                    textStrokeWidth: 0,
                    textStrokeColor: '#000000',
                    backgroundColor: '#FFFFFF00',
                    borderStyle: 'solid',
                    borderWidth: 0,
                    borderColor: '#000000',
                    borderRadius: 0,
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    }
                },
            }
        };
    }

    /**
     * Return the list of options this widget handles
     */
    getHandledOptions() {
        const handledOptions = super.getHandledOptions().concat([
            PdfLayout.OPTION_CONTACT_FIELD
        ]).filter(o => o !== PdfLayout.OPTION_TEXT);

        if (this.options?.field === 'birthdate') {
            handledOptions.push(PdfLayout.OPTION_DATE_FORMAT);
            handledOptions.push(PdfLayout.OPTION_DATE_OFFSET);
        }

        return handledOptions;
    }

    /**
     * Return this widget preview text as string
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {String} lang
     *                 - {Object} setting
     */
    getPreviewText(props) {
        const owner = previewOwner(props?.lang || 'fr');

        switch (this.options.field) {
            case 'title':
                return owner.title;
            case 'company':
                return owner.company;
            case 'firstname':
                return owner.firstname;
            case 'lastname':
                return owner.lastname;
            case 'fullname':
                return `${owner.firstname} ${owner.lastname}`;
            case 'fullname-reversed':
                return `${owner.lastname} ${owner.firstname}`;
            case 'email':
                return owner.email;
            case 'age':
                return owner.age;
            case 'birthdate':
                return this.options?.date_format
                    ? moment(owner.birthdate).locale(props?.lang || 'fr').format(this.options.date_format)
                    : owner.birthdate;
            case 'sex':
                return owner.sex;
            case 'phone':
                return owner.phone;
            case 'cellphone':
                return owner.cellphone;
            case 'language':
                return owner.language;
            case 'address.street':
                return owner.address.street;
            case 'address.city':
                return owner.address.city;
            case 'address.zip':
                return owner.address.zip;
            case 'address.country':
                return owner.address.country;
            default:
                return '...';
        }
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'user';
    }
}

export default OwnerInfoWidget;
